import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getCurrentUser, logout } from '../services/api';
import './Navigation.css';

function Navigation() {
  const location = useLocation();
  const user = getCurrentUser();

  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          Email Campaigns
        </Link>
        <ul className="nav-menu">
          <li>
            <Link
              to="/"
              className={location.pathname === '/' ? 'active' : ''}
            >
              Dashboard
            </Link>
          </li>
          <li>
            <Link
              to="/campaigns"
              className={location.pathname.includes('/campaigns') ? 'active' : ''}
            >
              Campaigns
            </Link>
          </li>
          <li>
            <Link
              to="/campaigns/new"
              className="button button-primary"
            >
              New Campaign
            </Link>
          </li>
          {user && (
            <>
              <li style={{ marginLeft: 'auto', padding: '0 1rem', color: '#666' }}>
                {user.name}
              </li>
              <li>
                <button
                  onClick={logout}
                  className="button button-secondary"
                  style={{ padding: '0.5rem 1rem' }}
                >
                  Logout
                </button>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
